import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full flex items-center justify-center px-4 py-10 md:py-16 bg-gradient-to-b from-[#050810] to-[#0a0f1a]" data-id="element-25">
      <div className="max-w-4xl mx-auto text-center" data-id="element-26">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-27">
          Aumentá el valor de tus sesiones de masajes{' '}
          <span className="text-[#D4A843]" data-id="element-28">en una semana</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-6 cursor-pointer" onClick={scrollToCompra} data-id="element-29">
          <img src="https://cdn.magicpatterns.com/uploads/pFqBHT4UTtFQHM8RGSUctk/MOCKUP.png" alt="Liberación Miofascial Pro" className="max-w-full h-auto mx-auto rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300" style={{
          maxHeight: '500px'
        }} data-id="element-30" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-base md:text-lg text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-31">
          Sistema eficiente para posicionarte mejor y aumentar el valor
          percibido por tus clientes
        </motion.p>

        <motion.a href="https://checkout.abastecedordigital.shop/cart/51761111400768:1" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="inline-block bg-[#D4A843] hover:bg-[#c49a3a] text-[#0a0f1a] font-bold text-lg md:text-xl px-10 py-5 rounded-lg shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-105" data-id="element-32">
          🚀 QUIERO ACCEDER AHORA
        </motion.a>

        {/* Social Proof Stats Module */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="mt-10 bg-[#050810] border border-[#D4A843]/30 rounded-xl p-5 md:p-8 max-w-md mx-auto" data-id="element-33">
          <div className="text-center mb-5" data-id="element-34">
            <div className="flex justify-center gap-1 mb-1" data-id="element-35">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#D4A843] text-[#D4A843]" data-id="element-36" />)}
            </div>
            <p className="text-lg font-bold text-[#D4A843]" data-id="element-37">4.9/5</p>
            <p className="text-sm font-semibold text-white mt-1" data-id="element-38">
              Elegido por terapeutas en toda Argentina
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-39">
              El sistema de liberación miofascial más completo y profesional del
              mercado
            </p>
          </div>

          <div className="grid grid-cols-2 gap-3" data-id="element-40">
            <div className="text-center p-3 bg-[#0a0f1a] rounded-lg" data-id="element-41">
              <p className="text-2xl md:text-3xl font-bold text-[#D4A843]" data-id="element-42">
                +800
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-43">
                Profesionales confían en el sistema
              </p>
            </div>
            <div className="text-center p-3 bg-[#0a0f1a] rounded-lg" data-id="element-44">
              <p className="text-2xl md:text-3xl font-bold text-[#D4A843]" data-id="element-45">
                4.9/5
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-46">Valoración promedio</p>
            </div>
            <div className="text-center p-3 bg-[#0a0f1a] rounded-lg" data-id="element-47">
              <p className="text-2xl md:text-3xl font-bold text-[#D4A843]" data-id="element-48">
                +180
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-49">
                Recursos clínicos y protocolos
              </p>
            </div>
            <div className="text-center p-3 bg-[#0a0f1a] rounded-lg" data-id="element-50">
              <p className="text-2xl md:text-3xl font-bold text-[#D4A843]" data-id="element-51">
                #1
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-52">
                Sistema elegido en Argentina
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}